// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"87404a39","455":"0408cead","977":"1fe35522"}[chunkId] + ".chunk.js";
};